import { render, staticRenderFns } from "./DeletionConfirm.vue?vue&type=template&id=60da55b9"
import script from "./DeletionConfirm.vue?vue&type=script&lang=ts"
export * from "./DeletionConfirm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports